<template>
  <v-container
    class="pa-2"
    fluid
  >
    <v-layout wrap>
      <v-flex
        class="pa-3"
        md4
        v-show="expertMode || !resolution"
        xs12
      >
        <v-select
          :items="[32, 64, 128, 256, 512]"
          label="Number of radial points"
          v-model="myRun.config.heliospheric_model.Grid.num_radial"
        ></v-select>
      </v-flex>
      <v-flex
        class="pa-3"
        md4
        v-show="expertMode || !resolution"
        xs12
      >
        <v-select
          :items="[2, 4, 8]"
          label="Angular resolution"
          suffix="deg"
          v-model="myRun.config.heliospheric_model.Grid.angular_resolution"
        ></v-select>
      </v-flex>
      <v-flex
        class="pa-3"
        v-show="!expertMode && resolution"
        xs12
      >
        <v-select
          :items="resolutions"
          label="Resolution"
          v-model="resolution"
        ></v-select>
      </v-flex>
      <v-flex
        class="pa-3"
        md4
        v-show="expertMode"
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.heliospheric_model.Grid.radial.outer_edge)"
          @blur="$v.myRun.config.heliospheric_model.Grid.radial.outer_edge.$touch()"
          @input="$v.myRun.config.heliospheric_model.Grid.radial.outer_edge.$touch()"
          hint="Outer radial boundary of the simulation box"
          label="Outer edge"
          suffix="AU"
          type="number"
          v-model="myRun.config.heliospheric_model.Grid.radial.outer_edge"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  data() {
    return {
      resolutions: [
        {
          text: 'low (128x8)',
          value: { num_radial: 128, angular_resolution: 8 },
        },
        {
          text: 'medium (256x4)',
          value: { num_radial: 256, angular_resolution: 4 },
        },
        {
          text: 'high (512x2)',
          value: { num_radial: 512, angular_resolution: 2 },
        },
      ],
    };
  },
  computed: {
    resolution: {
      get() {
        return this.resolutions.find((res) =>
          _.isEqual(res.value, {
            num_radial: this.myRun.config.heliospheric_model.Grid.num_radial,
            angular_resolution: this.myRun.config.heliospheric_model.Grid.angular_resolution,
          })
        );
      },
      set(newResolution) {
        this.myRun.config.heliospheric_model.Grid.num_radial = newResolution.num_radial;
        this.myRun.config.heliospheric_model.Grid.angular_resolution =
          newResolution.angular_resolution;
      },
    },
  },
};
</script>
